import { createElement } from 'react';
import { Icons } from './constants';
import { Gear } from './icons/Gear';
import { Eth } from './icons/Eth';
import { Dollar } from './icons/Dollar';
import { MagnifyingGlass } from './icons/MagnifyingGlass';
import { ChevronDown } from './icons/ChevronDown';
import { Globe } from './icons/Globe';
import { ArrowsRightLeft } from './icons/ArrowsRightLeft';
import { Coins } from './icons/Coins';
import { Photo } from './icons/Photo';
import { ChartLine } from './icons/ChartLine';
import { BookOpenText } from './icons/BookOpenText';
import { Discord } from './icons/Discord';
import { Twitter } from './icons/Twitter';
import { External } from './icons/External';
import { List } from './icons/List';
import { Sun } from './icons/Sun';
import { Moon } from './icons/Moon';
import { ArrowDown } from './icons/ArrowDown';
import { Check } from './icons/Check';
import { XMark } from './icons/XMark';
import { Funnel } from './icons/Funnel';
import { SpinnerGap } from './icons/SpinnerGap';
import { ExclamationTriangle } from './icons/ExclamationTriangle';
import { CheckCircle } from './icons/CheckCircle';
import { InformationCircle } from './icons/InformationCircle';
import { PlusCircle } from './icons/PlusCircle';
import { Plus } from './icons/Plus';
import { PencilSquare } from './icons/PencilSquare';
import { LockClosed } from './icons/LockClosed';
import { Gavel } from './icons/Gavel';
import { QuestionMarkCircle } from './icons/QuestionMarkCircle';
import { ChevronUp } from './icons/ChevronUp';
import { ChevronUpDown } from './icons/ChevronUpDown';
import { Swap } from './icons/Swap';
import { ShoppingCart } from './icons/ShoppingCart';
import { Money } from './icons/Money';
import { Ticket } from './icons/Ticket';
import { FlyingSaucer } from './icons/FlyingSaucer';
import { Ghost } from './icons/Ghost';
import { DropHalfBottom } from './icons/DropHalfBottom';
import { NoSymbol } from './icons/NoSymbol';
import { DocumentDuplicate } from './icons/DocumentDuplicate';
import { XLogo } from './icons/XLogo';
import { Bug } from './icons/Bug';
import { Base } from './icons/Base';
import { Arbitrum } from './icons/Arbitrum';

export type IconSizes = 12 | 16 | 20 | 24 | 32 | 48 | 72;

export interface IconProps {
  /**
   * The name of the icon to render
   * Must exist in `Icons` constant
   */
  name: Icons;
  /**
   * Any additional styling classes
   * If passed in they *must* set a height/width
   */
  className?: string;
  /**
   * Size
   */
  size?: IconSizes;
}

const iconMap = {
  [Icons.ARBITRUM]: Arbitrum,
  [Icons.ARROW_DOWN]: ArrowDown,
  [Icons.ARROWS_RIGHT_LEFT]: ArrowsRightLeft,
  [Icons.BASE]: Base,
  [Icons.BOOK_OPEN_TEXT]: BookOpenText,
  [Icons.CHART_LINE]: ChartLine,
  [Icons.CHECK]: Check,
  [Icons.CHECK_CIRCLE]: CheckCircle,
  [Icons.CHEVRON_DOWN]: ChevronDown,
  [Icons.CHEVRON_UP]: ChevronUp,
  [Icons.CHEVRON_UP_DOWN]: ChevronUpDown,
  [Icons.COINS]: Coins,
  [Icons.DISCORD]: Discord,
  [Icons.DOLLAR]: Dollar,
  [Icons.DOCUMENT_DUPLICATE]: DocumentDuplicate,
  [Icons.DROP_HALF_BOTTOM]: DropHalfBottom,
  [Icons.ETH]: Eth,
  [Icons.EXCLAMATION_TRIANGLE]: ExclamationTriangle,
  [Icons.EXTERNAL]: External,
  [Icons.FLYING_SAUCER]: FlyingSaucer,
  [Icons.FUNNEL]: Funnel,
  [Icons.GAVEL]: Gavel,
  [Icons.GEAR]: Gear,
  [Icons.GHOST]: Ghost,
  [Icons.INFORMATION_CIRCLE]: InformationCircle,
  [Icons.LIST]: List,
  [Icons.LOCK_CLOSED]: LockClosed,
  [Icons.SEARCH]: MagnifyingGlass,
  [Icons.MONEY]: Money,
  [Icons.MOON]: Moon,
  [Icons.NO_SYMBOL]: NoSymbol,
  [Icons.PENCIL_SQUARE]: PencilSquare,
  [Icons.PLUS]: Plus,
  [Icons.PLUS_CIRCLE]: PlusCircle,
  [Icons.QUESTION_MARK_CIRCLE]: QuestionMarkCircle,
  [Icons.SHOPPING_CART]: ShoppingCart,
  [Icons.SPINNER_GAP]: SpinnerGap,
  [Icons.SUN]: Sun,
  [Icons.SWAP]: Swap,
  [Icons.GLOBE]: Globe,
  [Icons.PHOTO]: Photo,
  [Icons.TICKET]: Ticket,
  [Icons.TWITTER]: Twitter,
  [Icons.X_LOGO]: XLogo,
  [Icons.X_MARK]: XMark,
  [Icons.BUG]: Bug,
};

const sizeMap = {
  12: 'h-3 w-3',
  16: 'h-4 w-4',
  20: 'h-5 w-5',
  24: 'h-6 w-6',
  32: 'h-8 w-8',
  48: 'h-12 w-12',
  72: 'h-18 w-18',
};

export const Icon = ({ className, size = 24, name }: IconProps) => {
  const IconComponent = iconMap[name] || 'span';

  return createElement(IconComponent, {
    className: `${className} ${sizeMap[size]}`,
    size,
  });
};

export default Icon;
